import { ProgressBar, Text2, Text5, skinVars } from '@telefonica/mistica';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatTimeConsumption, conversionToGB } from '../../utils/dataTransformation/unitsConversion';
import './index.scss';

export interface IExtraCallOrSms {
    data: any;
    text: string;
    isBlocked: boolean;
}

const ExtraCallOrSms: React.FC<IExtraCallOrSms> = ({ data, text, isBlocked }: IExtraCallOrSms) => {
    const { t } = useTranslation();

    let percent: number = 0;
    if (data) {
        percent = Math.round((data.current * 100) / data.max);
    }
    const colorTextGB = useMemo(() => {
        if (percent >= 80 && percent <= 99) {
            return skinVars.colors.warningHigh;
        } else if (percent >= 100) {
            return skinVars.colors.error;
        } else if (percent < 80) {
            return skinVars.colors.textPrimary;
        }
    }, [percent]);

    const colorProgressBar = useMemo(() => {
        if (isBlocked) {
            return skinVars.colors.neutralMedium;
        } else if (percent >= 80 && percent <= 99) {
            return skinVars.colors.warning;
        } else if (percent >= 100) {
            return skinVars.colors.errorHigh;
        } else if (percent < 80) {
            return skinVars.colors.success;
        }
    }, [percent, isBlocked]);

    return (
        <>
            {data && (
                <div className='extraCallsOrSms-component'>
                    <div>
                        <Text5 color={colorTextGB}>
                            {text === 'min' && `${formatTimeConsumption(data.current)}`}
                            {text === 'SMS' && `${data.current} ${text}`}
                            {text === 'GB' && `${conversionToGB(data.unit, data.current, 2)}`}
                        </Text5>
                    </div>
                    <div className='extraCallsOrSms-component-maxGb'>
                        <Text2 regular color={skinVars.colors.textSecondary}>
                            {data.max === -1 ? t('unlimited') : `${t('of')} ${conversionToGB(data.unit, data.max, 0)} `}
                        </Text2>
                    </div>
                    <div className='extraCallsOrSms-component-progressBar'>
                        <ProgressBar
                            progressPercent={data.max === -1 ? 100 : percent}
                            color={colorProgressBar}
                        ></ProgressBar>
                    </div>
                </div>
            )}
        </>
    );
};

export default ExtraCallOrSms;
